import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do PI firms reduce cost per signed case?",
    "a": "Own your SEO and ads pipeline instead of renting from directories. Directory leads close at 5–10%. Properly intaked SEO leads close at 25–40%. The math is decisive."
  },
  {
    "q": "Is Google Ads profitable for personal injury?",
    "a": "Yes — CPCs are the highest in legal, but signed case value justifies the spend with proper tracking, call recording, and intake QA. Without those, ads waste money."
  },
  {
    "q": "Should we build case-type-specific pages?",
    "a": "Yes — 'car accident lawyer', 'truck accident lawyer', 'motorcycle accident lawyer' each rank separately. Generic 'personal injury' pages lose to specialists."
  },
  {
    "q": "How important are reviews for PI?",
    "a": "Critical — review velocity and quality directly impact Map Pack rank and signed-case rate. We build review workflows into your intake process."
  },
  {
    "q": "Do you handle Spanish-language marketing?",
    "a": "Yes — Spanish-language PI pages, ads, and intake convert at high rates across Colorado. We build bilingual pipelines when relevant."
  }
];

export const Route = createFileRoute("/personal-injury-attorney-marketing-colorado")({
  head: () =>
    industryMarketingHead("Personal Injury Attorney", "personal injury law firm", "personal-injury-attorney-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Personal Injury Attorney"}
      industryLower={"personal injury law firm"}
      slug={"personal-injury-attorney-marketing-colorado"}
      subheadline={"We help Colorado personal injury firms build a steady, signed-case pipeline — without paying directory fees on every lead."}
      painPoints={["You pay $200–$500 per directory lead and most don't sign","Larger firms outrank you for your own city and case types","Your case results don't show up where prospects actually search"]}
      serviceDescriptions={{
        seo: "Rank for car accident, truck accident, motorcycle, slip-and-fall, wrongful death, and every PI case type across every Colorado market.",
        googleMaps: "Own 'personal injury lawyer near me' in the Map Pack with reviews and case results that convert.",
        webDesign: "Case-type landing pages with results, attorney credibility, and 24/7 intake forms tuned to convert.",
        ppc: "Profitable Google Ads tuned to high-value PI searches with strict call tracking and intake QA.",
        geoAi: "Get cited when accident victims ask ChatGPT 'best personal injury lawyer in Denver' or 'car accident attorney near me'.",
        socialMedia: "Authority and case-result content that converts referrals and warm leads into signed cases.",
      }}
      testimonial={{"quote":"Cost per signed case dropped 60% in six months. We replaced Avvo and lead-gen spend with our own pipeline.","role":"Managing Attorney","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Personal injury lawyer marketing in Colorado Springs","description":"Compete with the major Colorado Springs PI firms across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Personal injury lawyer marketing in Denver","description":"Win signed cases in Denver's high-stakes PI market."},{"to":"/boulder-digital-marketing","label":"Personal injury lawyer marketing in Boulder","description":"Build pipeline across Boulder County PI cases."}]}
    />
  ),
});
